import React from 'react';

interface NewChartChoiceModalProps {
  onClose: () => void;
  onChooseChordGrid: () => void;
  onChoosePianoRec: () => void;
}

const KUMBH = 'Kumbh Sans, sans-serif';

// Shared label style with the desktop nav (style_a1506bb5: Kumbh Sans 500 SMALL_CAPS #D3CCBD)
const choiceLabel: React.CSSProperties = {
  fontFamily: KUMBH,
  fontWeight: 500,
  fontSize: 16,
  fontVariantCaps: 'small-caps',
  color: '#D3CCBD',
};

/**
 * Mobile "New" entry point — lets the user pick between starting a blank chord
 * grid or jumping straight into the MiniDaw piano recorder.
 */
const NewChartChoiceModal: React.FC<NewChartChoiceModalProps> = ({ onClose, onChooseChordGrid, onChoosePianoRec }) => {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="rounded-2xl shadow-2xl w-full max-w-lg p-7"
        style={{ backgroundColor: '#161616', border: '1px solid rgba(255,255,255,0.08)' }}
        onClick={e => e.stopPropagation()}
      >
        <header className="flex justify-between items-center mb-6">
          <h2 style={{ fontFamily: KUMBH, fontWeight: 700, fontSize: 24, fontVariantCaps: 'small-caps', color: '#F4F1EB' }}>
            New
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </header>
        <div className="grid grid-cols-2 gap-4">
          <button
            onClick={onChooseChordGrid}
            className="flex flex-col items-center gap-3 p-6 rounded-xl transition-colors"
            style={{ backgroundColor: '#231E1B', border: '1px solid rgba(255,255,255,0.08)' }}
            onMouseEnter={e => (e.currentTarget.style.borderColor = '#DB9817')}
            onMouseLeave={e => (e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)')}
          >
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#DB9817" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="20" x2="18" y2="10"></line>
              <line x1="12" y1="20" x2="12" y2="4"></line>
              <line x1="6" y1="20" x2="6" y2="14"></line>
            </svg>
            <span style={choiceLabel}>Chord Grid</span>
          </button>
          <button
            onClick={onChoosePianoRec}
            className="flex flex-col items-center gap-3 p-6 rounded-xl transition-colors"
            style={{ backgroundColor: '#231E1B', border: '1px solid rgba(255,255,255,0.08)' }}
            onMouseEnter={e => (e.currentTarget.style.borderColor = '#DB9817')}
            onMouseLeave={e => (e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)')}
          >
            <img src="/figma-assets/edit-mode/icon-piano-rec.svg" width="40" height="40" alt="" style={{ display: 'block' }} />
            <span style={choiceLabel}>Piano Rec</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewChartChoiceModal;
